<template>
  <fragment>
    <c-hero-split />
    <c-features-tiles />
    <c-roadmap top-divider type="student" />
    <c-clients
      top-divider
      :headingTitle="$t('student.clients.title')"
      :headingText="$t('student.clients.text')"
    />
    <c-testimonial top-divider type="student" />
    <c-generic-section top-divider>
      <div class="container-xs">
        <c-section-header :data="faqHeader" class="center-content" />
        <c-accordion>
          <c-accordion-item :title="$t('student.faq.one.title')" active>{{
            $t("student.faq.one.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('student.faq.two.title')">{{
            $t("student.faq.two.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('student.faq.three.title')">{{
            $t("student.faq.three.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('student.faq.four.title')">{{
            $t("student.faq.four.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('student.faq.five.title')">{{
            $t("student.faq.five.text")
          }}</c-accordion-item>
          <c-accordion-item :title="$t('student.faq.six.title')">{{
            $t("student.faq.six.text")
          }}</c-accordion-item>
        </c-accordion>
      </div>
    </c-generic-section>
    <section id="post-project" class="features-split" top-divider>
      <div class="container">
        <div class="features-split-inner section-inner">
          <div class="split-wrap">
            <div class="split-item">
              <div
                class="split-item-image reveal-scale-up split-item-image-fill"
                data-reveal-container=".split-item"
                data-reveal-delay="200"
              >
                <h3
                  class="mt-0 mb-16 reveal-from-bottom"
                  data-reveal-container=".split-item"
                >
                  {{ $t("student.contact.headline") }}
                </h3>
                <p>{{ $t("student.contact.subhead") }}</p>
                <ul>
                  <li>{{ $t("student.contact.benefits.one") }}</li>
                  <li>{{ $t("student.contact.benefits.two") }}</li>
                  <li>{{ $t("student.contact.benefits.three") }}</li>
                </ul>
              </div>
              <div class="split-item-content center-content-mobile has-shadow">
                <form
                  action="https://formcarry.com/s/p-KG88yVi3z"
                  method="POST"
                  accept-charset="UTF-8"
                >
                  <div class="mt-16">
                    <label class="form-label" for="form-name">Full name</label>
                    <c-input
                      id="name"
                      name="name"
                      type="text"
                      label-hidden
                      :placeholder="yourName"
                      required="true"
                    ></c-input>
                  </div>
                  <div class="mt-16">
                    <label class="form-label" for="form-name"
                      >Your phone number</label
                    >
                    <c-input
                      id="phone"
                      name="phone"
                      type="phone"
                      label-hidden
                      :placeholder="yourPhone"
                      required="true"
                    ></c-input>
                  </div>
                  <div class="mt-16">
                    <label class="form-label" for="form-name"
                      >Your university email</label
                    >
                    <c-input
                      id="email"
                      name="email"
                      type="email"
                      label-hidden
                      :placeholder="yourEmail"
                      required="true"
                    ></c-input>
                  </div>
                  <div class="mt-32 form-checkbox">
                    <label>
                      <input type="checkbox" name="notice" required="true" />
                      <p v-html="$t('employer.contact.notice')"></p>
                    </label>
                  </div>
                  <input type="hidden" name="_gotcha" />
                  <!-- use this to prevent spam -->
                  <div class="cta-action mt-8 mb-16">
                    <input
                      class="cta-action button button-primary button-wide-mobile"
                      tag="a"
                      color="primary"
                      type="submit"
                      :value="$t('student.contact.action')"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </fragment>
</template>

<script>
import CLayout from "@/layouts/LayoutDefault.vue";
import CHeroSplit from "@/components/sections/HeroSplit.vue";
import CFeaturesTiles from "@/components/sections/FeaturesTiles.vue";
import CTestimonial from "@/components/sections/Testimonial.vue";
import CGenericSection from "@/components/sections/GenericSection.vue";
import CAccordion from "@/components/elements/Accordion.vue";
import CAccordionItem from "@/components/elements/AccordionItem.vue";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CRoadmap from "@/components/sections/Roadmap.vue";
import CClients from "@/components/sections/Clients.vue";
import CInput from "@/components/elements/Input.vue";

export default {
  name: "Student",
  components: {
    CHeroSplit,
    CFeaturesTiles,
    CRoadmap,
    CClients,
    CTestimonial,
    CGenericSection,
    CAccordion,
    CAccordionItem,
    CSectionHeader,
    CInput,
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  computed: {
    faqHeader() {
      return {
        title: this.$i18n.t("student.faq.title"),
      };
    },
    yourName() {
      return this.$i18n.t("student.contact.name");
    },
    yourNameLabel() {
      return this.$i18n.t("");
    },
    yourEmail() {
      return this.$i18n.t("student.contact.email");
    },
    yourEmailLabel() {
      return this.$i18n.t("student.contact.emailLabel");
    },
    yourPhone() {
      return this.$i18n.t("student.contact.phone");
    },
    yourPhoneLabel() {
      return this.$i18n.t("student.contact.phoneLabel");
    },
  },
  methods: {
    submitApplication() {
      window.analytics.track("Student registration");
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none !important;
}
@media (max-width: 640px) {
  .center-content-mobile {
    text-align: initial;
  }
  .cta-action {
    text-align: center;
  }
}
html {
  scroll-behavior: smooth;
}
.split-item-content {
  padding: 32px;
}
input[type="submit"] {
  vertical-align: middle !important;
  width: 100% !important;
  color: #fff !important;
  background-color: #ff6163 !important;
}
.form-checkbox {
  display: inline-block;
  input {
    padding-left: 0px;
  }
  p {
    padding-left: 8px;
  }
}
.cta-slogan {
  ul {
    list-style-type: none;
    li:before {
      content: "\2713\0020";
    }
  }
}
</style>
